module.exports = __webpack_public_path__ + "static/logo-e2022529db12f1a2542f7e3d68f66b4f.png";